import { gql } from 'graphql-request'

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign($updateCampaignInput: UpdateCampaignInput!) {
    updateCampaign(updateCampaignInput: $updateCampaignInput) {
      id
    }
  }
`
